import './PlanAssigneeFieldModal.style.less'
import { Button, Col, Modal, Row, Select } from 'antd'
import { useEffect, useState } from 'react'
import { isNull, noop } from 'lodash'
import { useQuery } from 'react-query'
import { getCollaboratorsForTasks } from '@/screens/Order/Pages/Order.transform'
import { getUrlParams, isEmptyValue } from '@/utils/common'

function transformCollaborator(value) {
  return value.map((item) => {
    return {
      label: item.user.first_name + ' ' + item?.user.last_name,
      value: item.user.id,
    }
  })
}

function PlanAssigneeFieldModal(props: {
  onClose: () => any
  onsubmit: (assignee: any) => any
  fieldName: string
  defaultAssignee: any
  taskId: any
}) {
  const { onClose, onsubmit } = props
  const [showError, setshowError] = useState<string>(null)
  const [assignee, setAssignee] = useState(null)

  const { data, isLoading } = useQuery('GET_ASSIGNEE', async () => {
    return transformCollaborator(
      await getCollaboratorsForTasks(getUrlParams('orderKey'))
    )
  })

  useEffect(() => {
    if (!isEmptyValue(data)) {
      if (props.defaultAssignee) {
        if (data.some((item) => item.value == props.defaultAssignee.user.id)) {
          setAssignee(props.defaultAssignee.user.id)
        }
      }
    }
  }, [data])

  const onSubmit = () => {
    if (isNull(assignee)) {
      setshowError('Assignee Cannot be empty')
    } else {
      setshowError(null)
      onsubmit(assignee)
    }
  }

  return (
    <Modal
      className={'dialog-set-plan'}
      title={props.fieldName}
      width={520}
      open={true}
      onCancel={onClose}
      footer={[
        <Button
          className="dialog-cancel-button default-dialog-button"
          key="submit"
          type="primary"
          shape="round"
          onClick={onClose}
        >
          Cancel
        </Button>,
        <Button
          className="default-dialog-button"
          key="save"
          type="primary"
          shape="round"
          onClick={onSubmit}
        >
          Save
        </Button>,
      ]}
    >
      <div className="modal-plan-assign-field">
        <Row align={'middle'}>
          <Col span={8}>
            <p className="title">Assignee</p>
          </Col>
          <Col span={16}>
            {!isLoading && (
              <Select
                allowClear
                showSearch
                placeholder="Select Assignee"
                size="large"
                filterOption={false}
                onSearch={noop}
                value={assignee}
                notFoundContent={'Not found'}
                onSelect={(data) => setAssignee(data)}
              >
                {data?.map((item) => {
                  return (
                    <Select.Option value={item.value} key={item.label}>
                      {item.label}
                    </Select.Option>
                  )
                })}
              </Select>
            )}
            {showError && (
              <span className="field-required-text">{showError}</span>
            )}
          </Col>
        </Row>
      </div>
    </Modal>
  )
}

export default PlanAssigneeFieldModal
